import { TagCategory, type GetQuestionByIdQuery } from '@exam-management/graphql';
import type {
  QBankStructureLevel,
  QBankStructureLevelItemWithLevel,
} from '@exam-management/qbs-provider';
import {
  getCognitiveDomain,
  type QContentDetailFormContextData,
} from '@exam-management/qcontent-management';

type Question = GetQuestionByIdQuery['qctGetQuestionById'];

export async function getQuestionDefaultValues(
  question: Question,
  qbsLevels: QBankStructureLevel[],
  qbsLevelItems: QBankStructureLevelItemWithLevel[],
) {
  if (!question || !question.questionGroup) return;
  const {
    pValue,
    bIndexValue,
    tags,
    metadata,
    questionStructures,
    details,
    correctAnswer,
    solution,
    learningObjectiveStatement,
  } = question;
  const { choices, reference } = metadata;

  const levelItemLocation: Record<string, { label: string; value: string } | undefined> = {};
  const locations = qbsLevelItems.filter((qBankStructureLevelItem) =>
    questionStructures?.some(
      (questionStructure) => questionStructure.refLevelItemId === qBankStructureLevelItem.id,
    ),
  );

  for (const level of qbsLevels) {
    const currentCategory = level.category;
    const levelItem = locations.find(
      (location) => location.qBankStructureLevel.category === currentCategory,
    );
    if (!levelItem) {
      levelItemLocation[currentCategory] = undefined;
      continue;
    }

    levelItemLocation[currentCategory] = {
      label: levelItem.tag?.name ?? 'ไม่ระบุ',
      value: levelItem.id,
    };
  }

  const parsedDetails = details ?? '';
  const parsedCorrectAnswer = { value: correctAnswer?.value ?? undefined };
  const parsedSolution = solution?.value ?? '';
  const parsedReference = reference ?? '';

  const los = learningObjectiveStatement
    ? { label: learningObjectiveStatement.tag.name, value: learningObjectiveStatement.id }
    : null;

  const calculation = tags.find((tag) => tag.category === TagCategory.Calculation);
  const cognitiveDomain: QContentDetailFormContextData['properties']['cognitiveDomain'] =
    getCognitiveDomain(tags);

  return {
    detail: {
      details: parsedDetails,
      choices:
        choices.length > 0
          ? choices
          : [
              { value: '1', label: '', order: 1 },
              { value: '2', label: '', order: 2 },
              { value: '3', label: '', order: 3 },
              { value: '4', label: '', order: 4 },
            ],
      correctAnswer: parsedCorrectAnswer,
    },
    properties: {
      solution: parsedSolution,
      cognitiveDomain,
      reference: parsedReference,
      learningObjectiveStatement: los,
    },
    information: {
      pValue: {
        selected: 'pInitial',
        pInitial: pValue !== null ? pValue : undefined,
      },
      calculated: calculation ? (calculation.name === 'คำนวณ' ? 'true' : 'false') : '',
      bIndex: bIndexValue,
    },
    location: {
      ...levelItemLocation,
    },
  };
}
